/* eslint-disable eag/no-css-property */
/* eslint-disable react/forbid-component-props */
import {css} from 'styled-components';

interface PlaceholderProps {
  placeholder: string;
}

export function Placeholder(props: PlaceholderProps) {
  return (
    <p
      role="presentation"
      aria-hidden="true"
      css={css`
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        color: ${({theme}) => theme.colors.text.tertiary};
        font-size: 14px;
        line-height: 20px;
      `}
    >
      {props.placeholder}
    </p>
  );
}
